<template>
  <div style="width: 100%;">
    <div class="table-container-manufacturing">
      <table>
        <tr>
          <th style="background:transparent; border:none;"></th>
          <th style="background:#474C56;border-start-start-radius: 8px;">JULY</th>
          <th style="background:#5F646E;">AUGUST</th>
          <th style="background:#474C56;">SEPTEMBER</th>
          <th style="background:#5F646E;">OCTOBER</th>
          <th style="background:#474C56;">NOVEMBER</th>
          <th style="background:#5F646E;border-start-end-radius: 8px;">DECEMBER</th>
        </tr>
        <tr>
          <td class="name-row-cell first img-cell">SKU 1<br><span>Structure A</span>
            <img src="/images/why-digital/manufacturing-benefits/sku-one-row-thumbnail.png" alt="thumbnail">
          </td>
          <td class="img-cell"></td>
          <td class="img-cell"></td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/start-right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/start-right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/start-right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"></td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 2<br><span>Structure A</span>
            <img src="/images/why-digital/manufacturing-benefits/sku-two-row-thumbnail.png" alt="thumbnail">
          </td>
          <td class="img-cell"></td>
          <td class="img-cell"></td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td></td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 3<br><span>Structure A</span>
            <img src="/images/why-digital/manufacturing-benefits/sku-three-row-thumbnail.png" alt="thumbnail">
          </td>
          <td class="img-cell"></td>
          <td class="img-cell"></td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/block-right-white-line.png"
              alt="violet-block"></td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/block-right-white-line.png"
              alt="violet-block"></td>
          <td></td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 4<br><span>Structure A</span>
            <img src="/images/why-digital/manufacturing-benefits/sku-four-row-thumbnail.png" alt="thumbnail">
          </td>
          <td class="img-cell"></td>
          <td class="img-cell"></td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td></td>
        </tr>
        <tr>
          <td class="name-row-cell last" style="border-end-start-radius: 8px;">SKU 5<br><span>Structure A</span>
            <img src="/images/why-digital/manufacturing-benefits/sku-five-row-thumbnail.png" alt="thumbnail">
          </td>
          <td class="img-cell"></td>
          <td class="img-cell"></td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td class="img-cell"><img src="/images/why-digital/manufacturing-benefits/right-white-line.png"
              alt="gear-two">
          </td>
          <td style="border-end-end-radius: 8px;"></td>
        </tr>
        <tr>
          <td style="background:transparent; border:none;"></td>
          <td style="background:transparent; border:none;"></td>
          <td style="background:transparent; border:none;"></td>
          <td class="img-cell" style="background:transparent; border:none;"><img src="/images/why-digital/manufacturing-benefits/lower-sku-arrow.png"
              alt="gear-two">
          </td>
          <td class="img-cell" style="background:transparent; border:none;"><img src="/images/why-digital/manufacturing-benefits/lower-sku-arrow.png"
              alt="gear-two">
          </td>
          <td class="img-cell" style="background:transparent; border:none;"><img src="/images/why-digital/manufacturing-benefits/lower-sku-arrow.png"
              alt="gear-two">
          </td>
          <td style="background:transparent; border:none;"></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/scss/views/why-digital/manufacturing-time.scss";
@import '@/scss/_mixins.scss';

.table-container-manufacturing {
  width: 70%;
  margin: 0 auto;

  th {
    padding: 10px;
  }

  .img-cell {
    padding: 0;
    width: auto;
    min-width: 130px;

    img {
      width: auto;
      height: 106px;
    }
  }

  .name-row-cell {
    position: relative;

    img {
      position: absolute;
      bottom: 10px;
      left: -60px;
      width: auto;
      height: 75%;
    }
  }
}
</style>
